import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';
import { I18n } from 'utils/i18n';
import { useNavigate } from 'react-router';

const LoginRejectedScene = () => {
  const navigate = useNavigate();
  const onRetry = () => {
    navigate('/auth/login', { replace: true });
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography gutterBottom variant="h5">
        {I18n.t(`LoginRejectedScene.headline`)}
      </Typography>
      <Typography gutterBottom>{I18n.t(`LoginRejectedScene.You told us`)}</Typography>
      <Typography gutterBottom>{I18n.t(`LoginRejectedScene.If it was`)}</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          p: '20px',
          pr: '40px',
          justifyContent: 'flex-end',
        }}
      >
        <Button variant="contained" type="button" color="primary" onClick={onRetry}>
          {I18n.t(`LoginRejectedScene.Try again`)}
        </Button>
      </Box>
    </Box>
  );
};

export default LoginRejectedScene;
